export const bleIds = {
  uartService: '00000001-edc2-4359-aae1-a232dda621ca',
  tx: '00000002-edc2-4359-aae1-a232dda621ca', // tx characteristics of uartService
  rx: '00000003-edc2-4359-aae1-a232dda621ca', // rx characteristic of uartService
};
